<template>
  <div class="container" id="itb-breadcrumbs" v-if="breadCrumbs">
    <span v-for="(crumb, index) in breadCrumbs">
      <router-link
        :to="
          crumb.pathForTranslation
            ? '/' + $t(crumb.pathForTranslation)
            : crumb.path
        "
        v-if="crumb.path || crumb.pathForTranslation"
        >{{
          crumb.nameForTranslation ? $t(crumb.nameForTranslation) : crumb.name
        }}</router-link
      >
      <span v-else>{{
        crumb.nameForTranslation ? $t(crumb.nameForTranslation) : crumb.name
      }}</span>
      <span v-if="index < breadCrumbs.length - 1" class="itb-separator"></span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    host: String,
  },

  data() {
    return {
      graphicSubcategory2Name: "",
    };
  },
  computed: {
    ...mapGetters({
      params: "getPageParams",
    }),

    breadCrumbs() {
      return this.params.page_breadcrumbs;
    },

    currentTitle() {
      let title = "";
      let breadCrumbsWithoutHome = structuredClone(this.breadCrumbs);
      let routeNames = [];
      if (this.breadCrumbs && this.breadCrumbs.length > 0) {
        if ((this.breadCrumbs[0].path = "/")) {
          breadCrumbsWithoutHome.shift();
        }
        breadCrumbsWithoutHome.forEach((element, index) => {
          if (
            element.hasOwnProperty("nameForTranslation") &&
            element.nameForTranslation
          ) {
            routeNames.push(this.$t(element.nameForTranslation));
          } else if (element.hasOwnProperty("name") && element.name) {
            routeNames.push(element.name);
          }
        });

        if (
          this.$route.name == "graphicDetail" &&
          this.graphicSubcategory2Name
        ) {
          routeNames.splice(3, 0, this.graphicSubcategory2Name);
        }

        routeNames.reverse();

        title = routeNames.join(" - ") + " | " + this.host;
      } else {
        title = this.host;
      }

      return title;
    },
  },

  watch: {
    currentTitle() {
      this.changeTitle();
      this.getGraphicSubcategory2Name();
      this.$emit("updatePageTitle", this.currentTitle);
    },
  },

  created() {
    this.changeTitle();
    this.getGraphicSubcategory2Name();
    this.$emit("updatePageTitle", this.currentTitle);
  },

  methods: {
    getHost() {
      axios
        .get("/get-host")
        .then((response) => {
          this.host = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeTitle() {
      document.title = this.currentTitle;
    },

    getGraphicSubcategory2Name() {
      if (this.$route.name == "graphicDetail") {
        let subcategoryId = this.$route.params.subcategory2Alias.split("-")[0];
        axios
          .get("/get-graphic-subcategory-2-name/" + subcategoryId)
          .then((response) => {
            this.graphicSubcategory2Name = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>
